import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'FailedModal',
  setup(__props) {

const { showModal, modalContents } = useCommonStore();

const sentences = computed((): string[] => {
  return modalContents.description.split('\n');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    transitionName: "bounce",
    isModalOpen: _unref(showModal).isFail,
    errorTitle: _unref(modalContents).title,
    isErrorMeteIcon: true
  }, {
    contentDescription: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentences.value, (sentence, index) => {
        return (_openBlock(), _createElementBlock("p", {
          key: `fail_modal_${index}`
        }, _toDisplayString(sentence), 1))
      }), 128))
    ]),
    _: 1
  }, 8, ["isModalOpen", "errorTitle"]))
}
}

})